<template>
    <div class="login-model-pop-up-sec sign-up-wrapper" @click="closeCountryCodeOnOutsideClick">
        <div class="modal fade" id="register-btn" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
            data-bs-backdrop="static">
            <div class="modal-dialog">
                <div class="modal-content">
                    <button @click="refreshData()" type="button" class="btn-close" data-bs-dismiss="modal"
                        aria-label="Close">&#10006;</button>
                    <div class="modal-body">
                        <div class="login-body-sec">
                            <div class="login-body-lft">
                                <div class="forget-login">
                                    <div class="login-now">
                                        <div class="login-flow-heading">
                                            <div class="web-logo">
                                                <img loading="lazy" :src="$siteSettings?.data?.aws_url + $siteSettings?.data?.storage_path.domain_image + $siteSettings?.data?.logo" alt="logo">
                                            </div>
                                        </div>
                                        <div id="msgFromServer"></div>
                                        <input type="hidden" id="csrf-token">
                                        <div class="number-var mak-gin sign-up-body">
                                            <div class="input-wrap sign-up-row">
                                                <div class="contact-info-wrapper">
                                                    <div class="country-code-flag-top-wrapper" >
                                                        <div v-if="countryCodeList && countryCodeList[contIndex]" class="country-code-flag-top-sec" @click="openCountryCode()" :class="{ 'disabled': timerRunning }">
                                                            <img loading="lazy" :src="countryCodeList[contIndex]?.flag"> <span>+{{ countryCodeList[contIndex]?.phonecode }}</span>
                                                            <i class="fa-solid fa-caret-down"></i>
                                                        </div>
                                                        <ul class="country-code-flag-sec " :class="checkCountryCodeSelect ? 'show-country-code' :''">
                                                            <template v-for="(allowedCountry, countryIndex) in countryCodeList" >
                                                                <li v-if="allowedCountry?.phonecode != countryCodeList[contIndex]?.phonecode" 
                                                                    :key="countryIndex"  @click="selectCountryCode(countryIndex,allowedCountry?.phonecode)">
                                                                    <img loading="lazy" :src="allowedCountry?.flag"> <span>+{{ allowedCountry.phonecode }}</span>
                                                                </li>
                                                            </template>
                                                        </ul>
                                                    </div>
                                                    <div class="input-left">
                                                        <input type="tel" class="form-control" v-model="form.mobileNo" :class="init.mobile && checkValidation?.mobile?.length > 0 ? 'border border-2 border-danger': ''"  
                                                            @input="form.mobileNo = $helper.sanitizeNumber(form.mobileNo,9999999999); validate()" 
                                                            :disabled="resendOtp && timerRunning"
                                                            id="mobile"  :placeholder="$t('enter-mobile-number','Enter Mobile Number') + '*'" maxlength="10" required>
                                                    </div>
                                                    <button @click="otpBtnCall()" type="button" id="otp-btn" :disabled=" timerRunning"
                                                    class="thm-btn otp-btn get-otp-btn send_otp_btn" :class="{'resend__otp' : resendOtp && !timerRunning}">
                                                        <span v-if="!loadingOtp">{{ timerRunning ? formatTime(minutes) + ":" + formatTime(seconds) : resendOtp ? $t('resend-otp',"Resend OTP") : $t('get-otp',"Get OTP") }}</span>
                                                        <div v-if="loadingOtp" class="text-center" id="Otp_loader">
                                                            <div class="spinner-border" role="status">
                                                                <span class="visually-hidden">{{$t('loading','Loading')}}...</span>
                                                            </div>
                                                        </div>
                                                    </button>
                                                </div>
                                                <div v-if="init.mobile && checkValidation?.mobile?.length > 0">
                                                    <template v-for="(err, index) in checkValidation?.mobile" :key="index">
                                                        <p class="error-text">&#8226; {{ $t(err.lang, err.error) }}</p>
                                                    </template>
                                                </div>
                                                <div v-if="init.mobile && form.mobileNo.length == 10 && !isOtpApiCalled && getOTPmsg && !loadingOtp">
                                                    <p class="error-text">&#8226; {{$t('please-click-on-send-otp','Please Click on Get OTP')}}</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="mak-gin password-inpt" v-if="isOtpApiCalled">
                                            <input type="tel" class="form-control input-boxes" name="otp" maxlength="6" 
                                            :class="isOtpApiCalled && init.otp && checkValidation?.otp?.length > 0 ? 'border border-2 border-danger': ''" :placeholder="$t('enter-otp','Enter OTP')+'*'"
                                            @input="form.otp = $helper.sanitizeNumber(form.otp, 999999); validate()" id="otp-input" v-model="form.otp" required="">
                                            <div v-if="isOtpApiCalled && init.otp && checkValidation?.otp?.length > 0" class="mt-2">
                                                <template  v-for="(err, index) in checkValidation?.otp" :key="index" >
                                                    <p class="error-text">&#8226; {{ $t(err.lang, err.error) }}</p>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="code-hyper" v-if ="!isSetUserId &&  !isRefral">
                                            <a href="javascript:void(0)" @click="isSetUserId =! isSetUserId">{{$t('set-user-id','Want to set UserID')}}?</a>
                                        </div>
                                        <div class="mak-gin password-inpt" v-if ="isSetUserId || isRefral">
                                            <input type="text" class="form-control input-boxes" maxlength="25" minlength="6" id="inputPassword2" 
                                                @input="form.userName = $helper.sanitizeDetails('userId', form.userName); validate()"
                                                :placeholder="$t('enter-user-id','Enter User ID')" v-model="form.userName" :class="isOtpApiCalled && init.userId && checkValidation?.userId?.length > 0  ? 'border border-2 border-danger': ''" >
                                            
                                            <div v-if="isOtpApiCalled && init.userId && checkValidation?.userId?.length > 0" class="mt-2">
                                                <template v-for="(err, index) in checkValidation?.userId" :key="index">
                                                    <p class="error-text">&#8226; {{ $t(err.lang, err.error) }}</p>
                                                </template>
                                            </div>
                                        </div>

                                        <div class="mak-gin password-inpt">
                                            <input :type="passwordFieldType" class="form-control toggle-password" name="password" maxlength="20"
                                                id="password" :placeholder="$t('enter-password','Enter Password') + '*'" v-model="form.password" @input="form.password = $helper.sanitizeDetails('password', form.password, 20); validate()"
                                                :class="isOtpApiCalled && init.password && checkValidation?.password?.length > 0 ? 'border border-2 border-danger': ''" aria-describedby="password">

                                            <div class="showHide-pass" v-if="loginMethod == 'password'"  @click="togglePasswordVisibility('passwordFieldType')">
                                                <!-- <i class="fa-solid" :class="passwordFieldType === 'password' ? 'fa-eye-slash' : 'fa-eye'"></i> -->
                                                <img loading="lazy" :src="passwordFieldType === 'password' ? require('@/assets/images/eye-slash.svg') : require('@/assets/images/eye.svg')" alt=""/>
                                            </div>

                                            <div v-if="isOtpApiCalled && init.password && checkValidation?.password?.length > 0" class="mt-2">
                                                <template v-for="(err, index) in checkValidation?.password" :key="index">
                                                    <p class="error-text">&#8226; {{ $t(err.lang, err.error) }}</p>

                                                </template>
                                            </div>
                                        </div>
                                        <div class="mak-gin password-inpt">
                                            <input :type="confPasswordFieldType" class="form-control toggle-password" maxlength="20"
                                                id="confirm_password1" v-model="form.confirmPassword" @input="form.confirmPassword = $helper.sanitizeDetails('password', form.confirmPassword, 20); validate()"
                                                :class="isOtpApiCalled && init.confirmPassword && checkValidation?.confirmPassword?.length > 0 ? 'border border-2 border-danger': ''" 
                                                name="confirm_password1" :placeholder="$t('enter-confirm-password','Enter Confirm Password') + '*'" aria-describedby="password">
                                            <div class="showHide-pass" @click="togglePasswordVisibility('confPasswordFieldType')">
                                                <!-- <i class="fa-solid" :class="confPasswordFieldType === 'password' ? 'fa-eye-slash' : 'fa-eye'"></i> -->
                                                <img loading="lazy" :src="confPasswordFieldType === 'password' ? require('@/assets/images/eye-slash.svg') : require('@/assets/images/eye.svg')" alt=""/>
                                            </div>


                                            <div v-if="isOtpApiCalled && init.confirmPassword && checkValidation?.confirmPassword?.length > 0" class="mt-2">
                                                <template v-for="(err, index) in checkValidation?.confirmPassword" :key="index">
                                                    <p class="error-text">&#8226; {{ $t(err.lang, err.error) }}</p>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="code-hyper" v-if ="!isRefral && !hasUrlReferer">
                                            <a href="javascript:void(0)" @click="hasUrlReferer =! hasUrlReferer">{{$t('have-a-refferal-code','Have a referral code')}}?</a>
                                        </div>
                                        <div class="mak-gin password-inpt" v-if ="isRefral || hasUrlReferer">
                                            <input type="tel" class="form-control " id="refer_code" 
                                                :placeholder="$t('enter-referral-code-optional','Enter Referral Code (Optional)')" v-model="form.referCode" 
                                                @input="form.referCode = $helper.sanitizeDetails('referCode', form.referCode); validate()" 
                                                :disabled="isRefral">
                                                <div class="call-icon"><img loading="lazy" src="@/assets/images/signup-refer.webp"></div>
                                            <div v-if="init && checkValidation?.referCode?.length > 0" class="mt-2">
                                                <span v-for="(err, index) in checkValidation?.referCode" :key="index">
                                                    <p class="error-text">{{ $t(err.lang, err.error) }}</p>
                                                </span>
                                            </div>
                                        </div>
                                        <input type="hidden" id="isDownLine" value="">
                                        <button @click="signUpCall()" type="submit"
                                            class="btn thm-but  main-btn" id="submitBtn">
                                            <span v-if="!loadingSignUp">{{ $t('signup','register')}}</span>
                                            <div v-if="loadingSignUp" class="text-center" id="Otp_loader">
                                                <div class="spinner-border" role="status">
                                                    <span class="visually-hidden">{{ $t('loading','Loading') }}...</span>
                                                </div>
                                            </div>
                                        </button>
                                        <div class="login-flow-heading" v-if="$siteSettings?.data?.social_link && $siteSettings?.data?.social_link?.whatsappno1">
                                            <p>{{ $t('get-your-ready-made-id-from-whatsapp','Get Your Ready-Made ID From Whatsapp')}}</p>
                                        </div>
                                        <div class="whatsapp-btn Continue-with pt-0 mb-0 pb-0" v-if="$siteSettings?.data?.social_link && $siteSettings?.data?.social_link?.whatsappno1">
                                            <div class="button-whatsapp  mt-0 pt-0 mb-0 pb-0">
                                                <a :href="'//wa.me/' + $siteSettings?.data?.social_link?.whatsappno1"
                                                    class="btn-whatsapp blinking" target="_blank">
                                                    <button type="button" class="btn thm-but" id="regWhatsApp">
                                                        <img loading="lazy" src="@/assets/images/whatsapp-social.svg" alt="whatsApp-icon">
                                                        <span class="blinking">{{ $t('whatsapp-now','Whatsapp Now')}}</span>
                                                    </button> 
                                                </a>
                                            </div>
                                        </div>
                                        <p class="forpass-in">
                                            {{ $t('already-have-an-account','Already have an account?')}}
                                            <a ref="open_login_modal"
                                                href="#login-btn" data-bs-toggle="modal" @click="refreshData">{{ $t('log-in','Log in')}}</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="login-body-rgt">
                                <div class="banner-side-img-sec">
                                    <div class="slider-model-pic">
                                        <div class="slider-model-pic">
                                            <img loading="lazy" src="@/assets/images/sl-lc-one-layer-two.webp" alt="layer-two" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import validate from '../services/authValidation';
import commonAuth from '../services/commonAuth';

export default {
    name: "SignUp",
    extends: commonAuth,
    data() {
        return {
            form: {
                code: this.$siteSettings.data && this.$siteSettings.data.country_code ? this.$siteSettings.data.country_code : "91",
                mobileNo: "",
                otp: '',
                password: "",
                confirmPassword: "",
                userName: "",
                referCode: this.getQueryParam("refer_code", window.location.href),
            },
            loadingSignUp: false,
            loadingOtp: false,
            hasUrlReferer: false,
            isRefral:false,
            contIndex:null,
            checkCountryCodeSelect:false,
            validationErrors : null,
            isSetUserId: false,
        };
    },
    computed: {
        countryCodeList(){
            return this.$siteSettings?.data?.country_code_list;
        },
        checkValidation() {
            return this.validationErrors;
        }
    },
    created() {
        if(this.$route.name == 'sign-up' && this.$siteSettings?.data?.business_type == 1){
            this.$router.push({ name: 'login' })
        }
        if((window.location.href).includes('refer_code')) {
            this.hasUrlReferer = true;
            this.isRefral =true;
        }
    },
    mounted(){
        this.contIndex =  this.countryCodeList?.findIndex(ci => ci.phonecode == this.$siteSettings.data.country_code)
        if(this.$route.name == 'sign-up' && !this.$auth?.status && this.$siteSettings?.data?.business_type == 2){
            setTimeout(()=> {
                this.$helper.openModal('#register-btn')
            }, 500)
            this.$router.push({name: 'Home'});
        }
        else if(this.$route.name == 'sign-up' && (this.$auth?.status || this.$siteSettings?.data?.business_type == 1)){
            this.$router.push({name: 'Home'});
        }
    },
    methods: {
        closeCountryCodeOnOutsideClick(event) {
            const countryCodeElement = this.$el.querySelector('.country-code-flag-top-wrapper');
            if (countryCodeElement && event && event.target && !countryCodeElement.contains(event.target)) {
                this.checkCountryCodeSelect = false;
            }
        },
        openCountryCode(){
            this.checkCountryCodeSelect = !this.checkCountryCodeSelect
        },
        selectCountryCode(code,phone_code){
            this.contIndex = code;
            this.form.code = parseInt(phone_code)
            this.checkCountryCodeSelect = !this.checkCountryCodeSelect
        },
        validate(){
            this.validationErrors = validate.areFieldsValid(
                'signup',
                this.form.mobileNo,
                this.form.otp,
                this.form.password,
                this.form.confirmPassword,
                this.form.referCode,
                this.form.userName,
            );
            return this.validationErrors;
        },
        otpBtnCall(){
            this.getOTPmsg = true;
            this.toggleInitPhn(true);
            this.validate();
            this.sendOtpCall();
        },
        toggleInitPhn(bool){
            this.init={
                mobile:bool
            }
        },
        toggleOTPInit(bool){
            this.init={
                otp:bool
            }
        },
        toggleInit(bool){
            this.init={
                otp:bool,
                password:bool,
                confirmPassword:bool,
                userId:bool
            }
        },
        formatTime(value) {
            return value < 10 ? `0${value}` : value;
        },
        signUpCall() {
            if (this.loadingSignUp) {
                return;    
            }
            this.toggleInitPhn(true);
            this.getOTPmsg = true;
            if(this.isOtpApiCalled) {
                this.toggleOTPInit(true);
            }
            if(this.getOtp()?.length){
                this.toggleInit(true)
            }
            if(Object.keys(this.validate())?.filter(key=> key !='referCode').length != 0){
                return;
            }
            if (!this.isOtpApiCalled) {
                this.$errorToast('Call for OTP.');
                return;
            } 
            else {
                this.signUpServiceCall();
            }
        },
        async signUpServiceCall() {
            this.loadingSignUp = true;
            let isDownLine = this.getQueryParam("downline", window.location.href);
            let data = {
                "phone": this.form.mobileNo,
                "cncode": this.form.code,
                "password": this.form.password,
                "otp": this.getOtp(),
                "isDownLine": isDownLine ? isDownLine : false,
                "refer_code": this.form.referCode,
                "userid": this.form.userName ? this.form.userName : null, 
            };
            this.$apiCall('post', 'REGISTER', data).then(response => {
                this.loadingSignUp = false;
                if (response) {
                    if (response.status == 200) {
                        if (response.data.status == 0) {
                            this.$errorToast(response.data.debug[0]);
                        }
                        else {
                            this.$successToast(response.data.message);
                            this.refreshData();
                            this.$helper.closeModal('register-btn')
                            setTimeout(() => {
                                this.$helper.openModal('#login-btn')
                            }, 500);
                            
                        }
                    }
                }
            }).catch(error => {
                this.loadingSignUp = false;
                this.$errorToast(error[0]);
            });
        },
        getQueryParam(paramName, url) {
            if (!url) url = location.href;
            paramName = paramName.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
            var regexS = "[\\?&]" + paramName + "=([^&#]*)";
            var regex = new RegExp(regexS);
            var results = regex.exec(url);
            return results == null ? null : results[1];
        }

    }
};
</script>
<style scoped>
</style>